"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
const propTypes = {
  /**
   * The svg of the icon to render
   */
  children: _propTypes.default.element.isRequired,
  /**
   * Set a custom class on the icon container element.
   */
  className: _propTypes.default.string,
  /**
   * Set a custom size for the icon. Must be a valid CSS dimension value. Note: uses inline styles.
   */
  customSize: _propTypes.default.string,
  /**
   * The ID of the icon to render.
   */
  icon: _propTypes.default.string,
  /**
   * Alternate text for screen readers. If a label is provided, the `role` attribute will be set to `img`, otherwise it will be set to `presentation`.
   */
  label: _propTypes.default.string,
  /**
   * Changes the fill color of the icon path
   */
  color: _propTypes.default.oneOf(['black', 'blue', 'brand-link-hover', 'brand-link', 'current', 'dark-gray', 'default', 'error', 'gray-20', 'gray-50', 'gray-60', 'gray-80', 'gray', 'success', 'warning', 'white']),
  /**
   * Changes the size of the icon from the default size to another supported size<br />
   * Sizes: xxs 12, xs 16, sm 20, md 24, lg 36, xl 48, xxl 60, xxxl 72;
   */
  size: _propTypes.default.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl']),
  /**
   * Set to `true` in order to change the icon fill color to the default disabled state color (i.e. opacity 50%).
   */
  isDisabled: _propTypes.default.bool,
  /**
   * Set to `true` in order to set inline styles for the icon width and height.
   */
  useInlineStyles: _propTypes.default.bool
};
const defaultProps = {
  className: '',
  icon: 'question-circle',
  size: 'md',
  isActive: false,
  isDisabled: false,
  useInlineStyles: false
};
const iconSizes = {
  xxs: 12,
  xs: 16,
  sm: 20,
  md: 24,
  lg: 36,
  xl: 48,
  xxl: 60,
  xxxl: 72
};
function Icon(props) {
  const {
    children,
    className,
    customSize,
    icon,
    label,
    isDisabled,
    color,
    size,
    useInlineStyles
  } = props;
  const iconSize = iconSizes[size];
  const iconClasses = (0, _classnames.default)(`asc-svg-icon asc-svg-icon--${icon}`, color && `asc-svg-icon--color-${color}`, size && `asc-svg-icon--size-${size}`, className, {
    'asc-svg-icon--disabled': isDisabled
  });
  const inlineStyles = useInlineStyles ? {
    display: 'inline-block',
    width: `${iconSize}px`,
    height: `${iconSize}px`
  } : {};
  if (customSize) {
    Object.assign(inlineStyles, {
      display: 'inline-block',
      width: customSize,
      height: customSize
    });
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: iconClasses,
    role: label ? 'img' : 'presentation',
    "aria-label": label,
    title: label || '',
    style: inlineStyles
  }, children);
}
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
var _default = exports.default = Icon;